import React, { useEffect, useState } from 'react';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios, {source} from '../../../httpClients/axios-datamerch'
import {authHeaders} from '../../../helpers'

import { CircularProgress, Backdrop, Card, CardContent, GridLegacy as Grid, Typography, Avatar } from '@mui/material';
import NotesIcon from '@mui/icons-material/Notes';
import { NumericFormat } from 'react-number-format'
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  avatar: {
    backgroundColor: theme.palette.warning.main,
    height: 56,
    width: 56
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  }
});

const TotalNotes = props => {
  const { account } = props;
  const classes = useClasses(styles);
  const [loading, setLoading] = useState(true)
  const [kpiValue, setKpiValue] = useState(0)
  
  useEffect(() => {
    setLoading(true)
    let url = `/widgets/total_notes`
    if (account){
      url = `/widgets/total_notes?account_id=${account}`
    }
    let config = authHeaders()
    axios.get(url, config)
    .then(response => {
      if (response){
        setLoading(false)
        setKpiValue(response.data.data)
      }
      else {
        setLoading(false)
      }
    })
    .catch(error => {
      setLoading(false)
    })
    
    return () => {
      source.cancel()
    }
  }, [])

  let kpi = (
    <CircularProgress color="inherit" />
  )
  if(!loading){
    kpi = (
      <Card>
        <CardContent>
          <Grid
            container
            justifyContent="space-between"
          >
            <Grid item>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
                variant="body2"
              >
                TOTAL NOTES
              </Typography>
              <Typography variant="h3"><NumericFormat value={kpiValue} displayType={'text'} thousandSeparator={true} /></Typography>
            </Grid>
            <Grid item>
              <Avatar sx={{
                  backgroundColor: "#fb8c00",
                  height: 56,
                  width: 56
                }}>
                <NotesIcon className={classes.icon} />
              </Avatar>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    )
  }
  
  return (
    <React.Fragment>
      {kpi}
    </React.Fragment>
  );
};

export default withErrorHandler(TotalNotes, axios)